import ElementUILocal from 'element-ui/lib/locale/lang/fi';

import country from './country/fi';
import state from './state/fi';
// 芬兰
export default {
  message: {
    title: 'Kassapiste',
    powerByOnerway: '<span class="ic-powerby"></span> tukema',
    status: {
      loading: 'Ladataan',
    },
    checkout: {
      timeTip:
        'Suorita maksu <span class="time">00:{time}</span>  minuutin kuluessa, muuten sivu aikakatkaistaan',
      timeTipsShort: 'Expirera dans <span class="time">00:{time}</span> :n kuluttua',
      billingAddressTip: 'Veloitus näkyy laskussasi nimellä {billingAddress}',
      cardInfo: 'Korttitiedot',
      cardNumber: 'Kortin numero',
      prepaidNumber: 'Kortin numero',
      summary: 'Tilauksen yhteenveto',
      expiredDate: 'Voimassaoloaika',
      issueDate: 'Issue date',
      cvv: 'CVC/CVV',
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      holderName: 'Kortinhaltijan nimi',
      walletAccountName: 'Nimi',
      orderno: 'Tilaus ID',
      website: 'Verkkosivusto',
      amount: 'Summa',
      pay: 'Maksa',
      payNow: 'Maksa nyt',
      update: 'Päivitä',
      deduction: 'Veloituksen Määrä',
      nextDeductionTime: 'Seuraava Veloitus Päivämäärä',
      subscriptionEndTime: 'Tilauksen Päättymispäivä',
      subscribeTo: 'Tilaa',
      try: 'Kokeile',
      then: 'Sitten',
      daysFree: '{X} päivää ilmaiseksi',
      forPayments: '{X} maksuerä | {X} maksuerää',
      startTrial: 'Aloita kokeilu',
      frequency: 'Joka',
      week: 'Viikko',
      day: 'Päivä',
      month: 'Kuukausi',
      year: 'Vuosi',
      cancel: 'Peruuta',
      tip: 'Vinkki',
      cancelPayTip: 'Haluatko peruuttaa tämän maksun?',
      yes: '​​Kyllä',
      no: 'Ei',
      subscription: 'Tilaus',
      subscribe: 'Tilaa',
      schedule: 'Maksuaika',
      endTime: 'loppu aika',
      subscriptionTip:
        'Maksun vahvistamisen jälkeen annat kauppiaan veloittaa korttiasi ehtojen mukaisesti jatkossa.',
      W: 'Viikko',
      D: 'Päivää',
      M: 'Kuukausi',
      Y: 'Vuosi',
      frequencyData: {
        D: '{time}päivä/aika',
        W: '{time}viikko/aika',
        M: '{time}kuukausi/aika',
        Y: '{time}vuosi/aika',
      },
      endTimeData: '{year}vuosi{month}kuukausi{day}päivä',
      billingAddress: 'Laskutusosoite/Yhteystiedot',
      country: 'Maa',
      province: 'Osavaltio/Lääni/Alue',
      address: 'Osoite',
      city: 'Kaupunki',
      postalCode: 'Postinumero',
      email: 'Sähköposti',
      phone: 'Puhelinnumero',
      street: 'Kadun numero',
      number: 'Talon numero',
      identityNumber: 'Veronumero',
      intallment: 'Lavastus',
      intallmentPlan: 'Asennussuunnitelma',
      paymentMethod: 'Maksutapa',
      bankName: 'Pankin nimi',
      iBan: 'Pankkitilin numero',
      contactName: 'Yhteyshenkilön nimi',
      birthDate: 'Syntymäpäivä',
      paymentCompleted: 'Maksu suoritettu',
      wechatPaymentTip: 'Skannaa QR-koodi WeChatilla maksaaksesi',
      paymentPending: 'Odottaa maksua',
      billingCountry: 'Laskutusmaa',
      billingCountryTip:
        'Valitse ensin laskutusmaa, jotta voimme suositella sinulle sopivaa maksutapaa.',
      nextStep: 'Seuraava askel',
      changeCountryTip:
        'Maanvaihdon jälkeen suosittelemme sinulle sopivia maksutapoja.',
      change: 'Muuta',
      scanCode: 'Skannaa se',
      txnTime: 'Kaupan aika',
      moreInfo: 'Lisää tietoa',
      applePayNotSupport: 'Tämä laite ei tue Apple Payta.',
      policy: {
        prefix: 'Napsauttamalla painiketta hyväksyt ',
        suffix: '',
      },
      privacy: 'tietosuojakäytännön',
      intallmentTip: 'Saatat joutua maksamaan korkoa maksueristä.',
      payInFull: 'Maksaa kokonaan',
      payIn: 'Maksa {count}:ssä',
      blikcode: 'BLIK-koodi',
      unavailable: 'Ei saatavilla',
      notSupportPaymentTips:
        'Maksutapa ei ole tällä hetkellä saatavilla. Palaa valintasivulle.',
      returnText: 'Palaa valintaan',
      returnMerchant: 'Takaisin kauppiaan sivulle',
      cvvTips:
        'CVC-koodi sijaitsee kortin takana valkoisen allekirjoitusnauhan oikealla puolella; se on aina viimeiset 3 numeroa Visassa ja Mastercardissa. American Expressissä se on 4 numeroa kortin etupuolella.',
      holderNameTips: 'Kortissa oleva koko nimi',
      continue: 'Jatka',
      validateCVVTitle: 'Turvallisuuden varmentaminen',
      validateCVVDesc:
        'Maksusi turvallisuuden vuoksi, vahvista korttisi CVC/CVV',
      // 订阅产品
      subscriptionProduct: 'Tilauksen yhteydestä',
      // 订阅费用
      subscriptionFee: 'Tilauksen hinta',
      // 订阅并支付
      subscriptionAndPay: ' ja maksa',
      // 订阅支付描述-第一行
      subscriptionPaymentLine1: 'Tilaa {productName} ja maksa',
      // 订阅支付描述-第二行
      subscriptionPaymentLine2: '{frequency} välein {duration} ajan, sitten {amount} {frequency} välein',
      // 首次订阅前缀
      firstSubscriptionPrefix: 'ensimmäisestä ',
      // 然后金额每
      thenAmountPer: 'Sitten {amount} {currency} {frequency}',
      // 更新成功
      updateSuccess: 'Paivitys onnistui',
      // 更新失败
      updateFailed: 'Paivitys epäonnistui',
      // 次
      times: 'Kerrat',
      free: 'ilmaiseksi',
      details: 'Yksityiskohdat',
      fold: 'Taittaa',
      specialPaymentDivider: 'Tai maksa kortilla',
      payWithCard: 'Maksa kortilla',
      subscriptionNo: 'Vahvistamalla tilauksesi sallit sinun veloittaa tulevat maksut ehtojen mukaisesti. Voit aina peruuttaa tilauksesi.',
      subscriptionNo1: 'Kokeilujakson päätyttyä sinulta veloitetaan {num}',

      subscriptionFrequency: {
        Y: 'joka {frequencyPoint}.vuosi',
        W: 'joka {frequencyPoint}.viikko',
        M: 'joka {frequencyPoint}.kuukausi',
        D: 'joka {frequencyPoint}.päivä',
      },
      subscriptionFrequencyWithoutPer: {
        Y: '{frequencyPoint} vuosi',
        W: '{frequencyPoint} viikko',
        M: '{frequencyPoint} kuukausi',
        D: '{frequencyPoint} päivä',
      },
      subscriptionFrequencyStandardized: {
        D_1: 'päivittäin',
        W_1: 'viikottain',
        W_2: 'joka toinen viikko',
        M_1: 'kuukausittain',
        M_3: 'joka kolmas kuukausi',
        M_6: 'joka kuudes kuukausi',
        Y_1: 'vuosittain',
      },
      subscriptionNo3: 'Voit aina peruuttaa ennen sitä',
      saveCardForFasterCheckout: 'Tallenna kortti nopeampaa maksua varten',
      saveCardDesc: 'Tallennettu turvallisesti tulevia ostoksia varten sivustolla {AppURL}. Poista milloin tahansa.',
      // Token Payment liittyvä - Kehittäjä：Nemo
      useNewCard: 'Lisää kortti',
      useSavedCard: 'Käytä tallennettua korttia',
      removeCard: 'Poista kortti',
      expired: 'Vanhentunut',
      removeCardTitle: 'Poista tämä kortti?',
      removeCardDescription: 'Tämä kortti poistetaan tallennetuista maksutavoistasi. Voit lisätä sen uudelleen myöhemmin tarvittaessa.',
      remove: 'Poista',
      cardRemovedSuccess: 'Kortti poistettu onnistuneesti',
    },
    dlocal: {
      amount: 'määrä',
      expirationDate: 'Määräaika',
      ticketNumber: 'Lipun numero',
      ticketImage: 'Lipun kuva',
      downloadTicket: 'Lataa lippu',
      searchForShops: 'etsiä kauppoja',
      fullBoletoView: 'Koko Boleto-näkymä',
      back: 'paluu',
      copySuccess: 'Kopioi',
      errorMsg: 'Parametrien haku epäonnistui.',
      instructionsTitle: 'Maksuohje',
      instructionsContentPIX:
        'ID Maksuohjeet:<br/>1. Monistustapahtuman ID<br/>2. Käytä tunnusta PIX-maksujen tunnistamiseen pankkisovelluksessasi tai lue QR-koodi pankin sovellukses',
      instructionsContentRedpagos:
        'Sinun on mentävä redpagos-myymälään maksun suorittamiseksi.<br/>Sanomalla henkilökorttisi numeron ja selventämällä, että haluat maksaa dlocal-laskun, pääset suorittamaan maksun.',
      instructionsContentOXXO:
        '1. Mene lähimpään oxxo-myymälään.<br/>2. Ilmoita ruutuun, että haluat suorittaa oxxopay-maksun.<br/>3. Sanele tässä kortissa oleva viitenumero kassalle kirjoitettavaksi.<br/>Suoraan myyntinäytölle.<br/>4. Suorita vastaava maksu käteisellä.<br/>5. Kun vahvistat maksun, kassa antaa sinulle tulostetun tositteen. Tästä voit tarkistaa, että maksu on tehty oikein. Säilytä tämä maksutosite.<br/>6. Lisätietoja maksusta saat help center -palvelustamme.',
      instructionsContentSPEI:
        '1. Välitön akkreditointi.<br/>2. Kun pankkisiirto on vastaanotettu, dlocal ilmoittaa toimitukselle ostamasi tuotteen/palvelun.<br/>3. Jos sinulla on maksuongelmia, käy asiakaspalveluportaalissamme.',
      instructionsContentSencillito:
        'Maksutoimeksianto henkilökohtaisesti:<br/>Sencilliton toimipaikassa voit suorittaa maksun antamalla viitenumeron ja ilmoittamalla, että haluat maksaa DLOCAL-laskun.<br/>Verkkomaksuohje:<br/>Maksun suorittamiseksi sinun on mentävä Portal Sencillitoon, valittava yrityksen hakukoneessa "dlocal" ja syötettävä kupongissa ilmoitettu koodi 134216.',
      instructionsContentServipag:
        'Primero díctale al cajero el código de servicio:<br/>Si es YoPag: "company_id"<br/>Si es por caja:"company_id2"',
      bankDetailsTitle: 'Pankkitiedot',
      bankDetailsSPEI:
        'Kirjaudu verkkopankkiin ja siirrä seuraavalle tilille. Huomaa, että käteismaksut eivät ole mahdollisia.<br/>Kohdepankki:<span class="detail-value">{bank}</span><br/>CLABE: <span class="detail-value">{clabe}</span><br/>Edunsaaja: <span class="detail-value">{beneficiary}</span><br/>Summa: <span class="detail-value">{amount} {currency}</span><br/>Maksutapa: <span class="detail-value">{concept}</span><br/>Viite: <span class="detail-value">{reference}</span>',
      paymentTypeTitle: 'Maksun tyyppi',
      paymentTypeServipag:
        'Por favor, indique al cajero el código de servicio<br/>Si es Empresa_1: <span class="company">{company1}</span><br/>Si se Empresa_2: <span class="company">{company2}</span>',
    },
    palmpay: {
      amount: 'Määrä',
      orderTips: 'Ole hyvä ja siirrä seuraavalle tilille',
      numberTitle: 'Tilinumero (vain tälle tapahtumalle)',
      copyBtnText: 'Kopioi tilinumero',
      expireText: 'Tilauksen voimassaoloaika päättyy {time}',
      bankName: 'Pankin nimi',
    },
    date: {
      month: {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        10: '10',
        11: '11',
        12: '12',
      },
    },
    result: {
      success: 'Maksu onnistui',
      failed: 'Maksu epäonnistui',
      unknow: 'Maksaa',
      unknowTip: 'Päivitä tilauksen tila tarkistaaksesi maksutuloksen',
      jump: 'Paluu kauppiaan luo <span class="hightlight">{time}s</span>',
      reason: 'Syy',
      processing: 'Käsittelyssä...',
      processingTitle: 'Käsittely',
      processingDescription: 'Transaktio käsitellään, ole hyvä ja odota.',
      processingButtonText: 'Vahvistaa',
      paymentStatusCheckText1: 'Maksu onnistui, mutta sivu ei ole päivitetty?',
      paymentStatusCheckText2: 'Klikkaa tästä tarkistamaan transaktion tila.',
      timeout: 'Sivun aikakatkaisu, aloita maksu uudelleen',
      invalid: 'Virheellinen tapahtumapyyntö',
      cancelled: 'Maksuhakemus on peruutettu, älä toista maksua',
      emptyPaymentMethod: 'Tälle maalle ei ole määritetty maksutapoja.',
      error: 'Virhe. Tarkista tapahtuman tulos ostossivuston tilaussivulta.',
      successPop: 'Voit palata kauppaan tarkastelemaan tilaustietojasi.',
      autoRedirectCountdown: '{seconds} sekuntia automaattiseen siirtymiseen kauppiaan sivulle',
    },
    validator: {
      input: 'Anna kelvollinen {field}',
      intallmentCardOrCountryNotSupport:
        'Osamaksua ei tueta korttityypin tai maan mukaan',
      required: 'Pakollinen',
    },
    error: {
      timeout: 'Verkko on epänormaali, yritä myöhemmin uudelleen',
      cardNumber: 'Kortin tiedot ovat virheelliset',
      retyrTitle: 'Maksu epäonnistui, yritä uudelleen.',
      brokenLinkMessage: 'Tämä maksulinkki voi olla rikki, vanhentunut tai maksupyyntöäsi käsitellään edelleen.',
      contactMerchantMessage: 'Ota yhteyttä kauppiaaseen, jos sinulla on kysyttävää.',
      errorTitle: 'Hups!',
      paymentLinkExpired: 'Maksulinkki vanhentunut',
    },
    country,
    state,
    QR: {
      amount: 'Määrä',
      details: 'Yksityiskohdat',
      paymentMethod: 'Maksutapa',
      validUntil: 'Voimassa',
      scanQrCode: 'Skannaa QR-koodi maksaaksesi',
      validFor24h: 'Voimassa 24h',
      orderId: 'Tilausnumero',
      website: 'Verkkosivusto',
      scanQrCodeOrDownload: 'Skannaa QR-koodi tai klikkaa "Lataa QR" tallentaaksesi ja skannataksesi sovelluksessasi maksaaksesi',
      downloadQr: 'Lataa QR',
      orderDetails: 'Tilauksen tiedot',
    },
  },
  ...ElementUILocal,
};
